import { listPages, listLayouts, listContentItems, saveManualPage } from '../services/compositionApi';
import { modelFromRow, planWrite, activeFraming } from '../components/book/atelier/store/pageModel';

// « Les afficher plus petites » (correctif 13, 2026-10-16) : un clic qui passe en mode « Entière » toutes les photos
// signalees comme trop peu nettes — la photo entiere rentre dans son cadre au lieu d'etre agrandie pour le remplir,
// ce qui augmente sa densite de pixels a l'impression.
//
// Passe par EXACTEMENT les memes briques que l'atelier (modelFromRow + planWrite + saveManualPage) : meme
// validation serveur, meme format de sauvegarde. Les pages que l'atelier ne sait pas reecrire (composees
// automatiquement, jamais retouchees a la main) ou incompletes sont comptees dans `skipped` et laissees telles quelles.
//
// `warnings` : entrees de GET /print-quality-check ({ pageIndex, itemId, kind }).
export async function fitFlaggedPhotosWhole(bookId, warnings) {
  const flaggedByPage = new Map();
  (warnings || []).filter((entry) => entry.kind === 'photo' && entry.pageIndex != null).forEach((entry) => {
    if (!flaggedByPage.has(entry.pageIndex)) flaggedByPage.set(entry.pageIndex, new Set());
    flaggedByPage.get(entry.pageIndex).add(entry.itemId);
  });
  if (flaggedByPage.size === 0) return { fixed: 0, skipped: 0 };

  const [rows, layouts, items] = await Promise.all([listPages(bookId), listLayouts(), listContentItems(bookId)]);
  const layoutsById = Object.fromEntries((layouts || []).map((layout) => [layout.id, layout]));
  const layoutsBySlug = Object.fromEntries((layouts || []).map((layout) => [layout.slug, layout]));
  const itemsById = Object.fromEntries((items || []).map((item) => [item.id, item]));

  let fixed = 0;
  let skipped = 0;
  for (const [pageIndex, itemIds] of flaggedByPage.entries()) {
    const row = (rows || []).find((entry) => entry.page_index === pageIndex);
    const model = row ? modelFromRow(row, { layoutsById, itemsById }) : null;
    if (!model || model.foreign || !Array.isArray(model.slotItemIds)) { skipped += itemIds.size; continue; }

    const framing = { ...activeFraming(model) };
    let touched = 0;
    model.slotItemIds.forEach((itemId, slotIndex) => {
      const slotId = model.slotIds && model.slotIds[slotIndex];
      if (!itemId || !slotId || !itemIds.has(itemId)) return;
      framing[slotId] = { fit: 'contain', focusX: 50, focusY: 50, zoom: 1 };
      touched += 1;
    });
    if (touched === 0) { skipped += itemIds.size; continue; }

    const plan = planWrite({ ...model, framing }, null, layoutsBySlug);
    if (!plan || plan.op !== 'complete') { skipped += touched; continue; }
    await saveManualPage(bookId, pageIndex, plan.payload);
    fixed += touched;
  }
  return { fixed, skipped };
}
